var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeAuctionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_19026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6673 0C26.1118 0 29.8895 1.55556 33.0006 4.66667C36.1118 7.77778 37.6673 11.5556 37.6673 16C37.6673 20.4444 36.1118 24.2222 33.0006 27.3333C29.8895 30.4444 26.1118 32 21.6673 32C17.2784 32 13.5007 30.4444 10.334 27.3333L12.9173 24.75C15.3062 27.1944 18.2229 28.4167 21.6673 28.4167C25.1118 28.4167 28.0423 27.2083 30.459 24.7917C32.8756 22.375 34.084 19.4444 34.084 16C34.084 12.5556 32.8756 9.625 30.459 7.20833C28.0423 4.79167 25.1118 3.58333 21.6673 3.58333C18.2229 3.58333 15.2923 4.79167 12.8757 7.20833C10.459 9.625 9.25065 12.5556 9.25065 16H14.584L7.33398 23.1667L7.25065 22.9167L0.333984 16H5.66732C5.66732 11.5556 7.22287 7.77778 10.334 4.66667C13.4451 1.55556 17.2229 0 21.6673 0ZM19.9173 8.91667H22.584V16.4167L28.7506 20.1667L27.5006 22.3333L19.9173 17.75V8.91667Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_19026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.3333,
    height: 32,
    fill: "white",
    transform: "translate(0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeAuctionIcon);
export default __webpack_public_path__ + "static/media/time-auction-icon.ad34b8ca987740cb6ba70635936e7908.svg";
export { ForwardRef as ReactComponent };